import React from 'react'

import { OrderItemPriceV3 } from '~/components/order-item-price/order-item-price-v3.styles'

import { ProductLine } from './v3.styles'

import type { TotalPriceProps } from './types'

export default ({ totalPrice }: TotalPriceProps) => {
  return (
    <ProductLine>
      <OrderItemPriceV3 price={totalPrice} />
    </ProductLine>
  )
}
